export { default } from './suggested-course';
